import React, { useContext, useMemo } from "react";
import { ScreenContext } from "@foundation/screen";
import styles from "~components/TopicModule/UserModulesTopicStories/userModulesTopicStories.module.css";
import { SingleTopicStoriesLoading } from "~components/TopicModule/SingleTopicStories";
import { NUMBER_OF_STORIES_PER_TOPIC } from "~components/TopicModule/constants";

export const UserTopicsStoriesPlaceholder = () => {
  const {
    breakpoints: { tablet, smallDesktop, largeDesktop },
  } = useContext(ScreenContext);

  const isMobile = useMemo(
    () => !tablet && !smallDesktop && !largeDesktop,
    [largeDesktop, smallDesktop, tablet]
  );

  return (
    <div className={styles.UserModulesTopicStories}>
      <div className={styles.header}>
        <h3 className={styles.title}>Market News</h3>
      </div>
      <div className={styles.topicStoriesContainer}>
        {isMobile ? (
          <div className={styles.loadingContainer}>
            <SingleTopicStoriesLoading
              numberOfRows={NUMBER_OF_STORIES_PER_TOPIC}
              length={2}
            />
          </div>
        ) : (
          <div className={styles.loadingContainer}>
            <SingleTopicStoriesLoading
              numberOfRows={NUMBER_OF_STORIES_PER_TOPIC}
              length={3}
            />
          </div>
        )}
      </div>
    </div>
  );
};
